import React from "react";

import Header from "../header";
import Footer from "../components/footer";

import { preshipmentLinks } from "./lib/constants";
import { Alert } from "components/alert/alert";

const PreshipmentLayout = ({ children }) => {
    return (
        <div>
            <Alert />
            <Header links={preshipmentLinks} />
            <div className="container">{children}</div>
            <Footer />
        </div>
    );
};

export default PreshipmentLayout;
